// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"369":"1b17de1b","787":"0695dfab"}[chunkId] + ".chunk.js";
};